module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"name":"Name","click behaviour":"Click behaviour","fullscreen":"Fullscreen","ignore":"Ignore","PDF settings":"PDF settings","expand pages":"Expand pages","select pages":"Select pages","page from":"from Page","page to":"to Page","caption":"Caption"}}')
  delete Component.options._Ctor
}
